import axios from "axios";
import { addErrorMessage } from "../redux/reducer/errorStore";
import { store } from "../redux/store";
import CryptoJS from "crypto-js";
const API_URL = process.env.REACT_APP_API_URL;

const SECRET_KEY = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY);

export function decryptResponse(encryptedB64) {
  // Many endpoints return plain JSON (object) or may be undefined/null.
  // Only attempt AES/Base64 decode for actual base64 strings.
  if (encryptedB64 == null) return null;
  if (typeof encryptedB64 !== "string") return encryptedB64;

  const encryptedData = CryptoJS.enc.Base64.parse(encryptedB64);
  const iv = CryptoJS.lib.WordArray.create(encryptedData.words.slice(0, 4), 16);
  const ciphertext = CryptoJS.lib.WordArray.create(
    encryptedData.words.slice(4),
    encryptedData.sigBytes - 16
  );
  const cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext });
  const decrypted = CryptoJS.AES.decrypt(cipherParams, SECRET_KEY, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8);
  if (!decryptedStr) return null;
  try {
    return JSON.parse(decryptedStr);
  } catch {
    return decryptedStr;
  }
}

const apiClient = axios.create({
  baseURL: API_URL,
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const session_id = localStorage.getItem("session_id");
    const userEmailId = localStorage.getItem("user_mailId");
    const userName = localStorage.getItem("user_name")
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (userEmailId) {
      config.headers.Userid = userEmailId;
    }
    if (session_id) {
      config.headers.Sessionid = session_id;
    }
    if (userName && userName !== "undefined") {
      config.headers["userName"] = userName;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);



apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    let errorMessage = "Something went wrong!";

    if (!error.response) {
      errorMessage = "Network error! Please check your connection.";
    } else {
      const status = error.response.status;
      const data = error.response.data;

      // Check if the error contains a custom message or error field
      if (data?.message) {
        errorMessage = data.message;
      } else if (data?.error) {
        errorMessage = data.error;
      } else {
        switch (status) {
          case 400:
            errorMessage = "Bad request. Please check your input.";
            break;
          case 401:
            errorMessage = "Unauthorized! Please log in.";
            break;
          case 403:
            errorMessage = "Forbidden! Access denied.";
            break;
          case 404:
            errorMessage = "Requested resource not found.";
            break;
          case 500:
            errorMessage = "Server error! Please try again later.";
            break;
          default:
            errorMessage = "Unexpected error occurred.";
        }
      }
    }

    store.dispatch(addErrorMessage(errorMessage));
    return Promise.reject(error);
  }
);

export default apiClient;
